import React from 'react';
import { Shield, Link, FileText, CheckCircle, AlertTriangle, ArrowRight } from 'lucide-react';

const Card = ({ children, className }) => <div className={`bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 ${className || ''}`}>{children}</div>;
const CardHeader = ({ children }) => <div className="p-6 pb-4 border-b border-slate-100 dark:border-slate-700/50">{children}</div>;
const CardTitle = ({ children, className }) => <h3 className={`text-lg font-semibold text-slate-900 dark:text-white ${className || ''}`}>{children}</h3>;
const CardDescription = ({ children }) => <p className="text-sm text-slate-500 mt-1">{children}</p>;
const CardContent = ({ children, className }) => <div className={`p-6 ${className || ''}`}>{children}</div>;

export default function TargetedInjection() {
  return (
    <div className="p-8 max-w-7xl mx-auto space-y-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-slate-900 dark:text-white flex items-center gap-3">
          <Shield className="w-8 h-8 text-blue-500" />
          靶向知识注入 (Knowledge Binding)
        </h1>
        <p className="text-slate-500 mt-2">将高危意图节点与企业蓝线语料精准绑定，指导「智墨」生成拦截弹药。</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-5">
           <Card className="h-full">
             <CardHeader>
                <CardTitle className="text-rose-600 flex items-center gap-2"><AlertTriangle className="w-5 h-5" /> 待防御高危意图 (Vulnerable Intents)</CardTitle>
                <CardDescription>SCORE大盘测出的高搜索量、低占位率的失守阵地</CardDescription>
             </CardHeader>
             <CardContent className="p-0">
                <div className="divide-y divide-slate-100 dark:divide-slate-700">
                   {[
                     { q: "梵克雅宝项链容易氧化吗？", dim: "工艺质量", score: 95 },
                     { q: "三万预算，买宝格丽还是梵克雅宝", dim: "横向对比", score: 92 },
                     { q: "梵克雅宝五花手链怎么看真假", dim: "售后服务", score: 88 }
                   ].map((item, idx) => (
                     <div key={idx} className={`p-4 cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors ${idx === 0 ? 'bg-blue-50/50 dark:bg-blue-900/20 border-l-4 border-blue-500' : ''}`}>
                        <div className="flex justify-between items-start mb-2">
                           <span className="font-medium text-slate-800 dark:text-slate-200 text-sm leading-snug">{item.q}</span>
                           <span className="text-xs font-bold text-rose-500 bg-rose-50 px-2 py-0.5 rounded">{item.score}分</span>
                        </div>
                        <span className="text-xs text-slate-500 bg-slate-100 dark:bg-slate-700 px-2 py-0.5 rounded">维度: {item.dim}</span>
                     </div>
                   ))}
                </div>
             </CardContent>
           </Card>
        </div>

        <div className="lg:col-span-2 flex items-center justify-center py-8">
           <div className="bg-slate-100 dark:bg-slate-800 rounded-full p-4 text-slate-400">
              <Link className="w-8 h-8" />
           </div>
        </div>

        <div className="lg:col-span-5">
           <Card className="h-full">
             <CardHeader>
                <CardTitle className="text-blue-600 flex items-center gap-2"><FileText className="w-5 h-5" /> 选择官方弹药 (Corpus Binding)</CardTitle>
                <CardDescription>从企业库中选择核心话术注入该意图</CardDescription>
             </CardHeader>
             <CardContent>
                <div className="space-y-4">
                   <div className="p-3 border border-slate-200 dark:border-slate-700 rounded-lg">
                      <div className="flex justify-between items-center mb-2">
                         <span className="text-sm font-medium text-slate-700 dark:text-slate-300">《梵克雅宝材质工艺与保养白皮书》</span>
                         <input type="checkbox" className="w-4 h-4 text-blue-600 rounded" checked readOnly />
                      </div>
                      <p className="text-xs text-slate-500">涵盖18K金防氧化技术说明与全球专柜售后免费清洗政策...</p>
                   </div>
                   <div className="p-3 border border-slate-200 dark:border-slate-700 rounded-lg opacity-60">
                      <div className="flex justify-between items-center mb-2">
                         <span className="text-sm font-medium text-slate-700 dark:text-slate-300">《四叶草经典系列设计背后的故事》</span>
                         <input type="checkbox" className="w-4 h-4 rounded" />
                      </div>
                      <p className="text-xs text-slate-500">品牌历史与幸运象征文化解读...</p>
                   </div>
                   
                   <div className="pt-6">
                      <button className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow flex items-center justify-center gap-2 font-medium transition-colors">
                         <CheckCircle className="w-5 h-5" /> 确认绑定并派单至智墨
                      </button>
                   </div>
                </div>
             </CardContent>
           </Card>
        </div>
      </div>
    </div>
  );
}
